import styled from 'styled-components';

export const BookmarkContainer = styled.div`
  position: relative;
  height: 100%;
  > svg path {
    position: relative;
    fill: ${props => props.color || 'black'};
  }
  > svg {
    top: ${props => props.top || '4'}px;
    position: absolute;
    z-index: 9;
    right: ${props => props.right || '6'}px;
    cursor: pointer;
  }
  :hover {
    .section-podcast-hero--image-container,
    .tool-card--image-container,
    .card--cover {
      background-color: black;

      .section-podcast-hero--image,
      .tool-card--image,
      .card--cover-image {
        opacity: 0.5;
      }
      .card--cover-mark-icon,
      > svg {
        opacity: 1;
      }
    }
    > a > .gatsby-image-wrapper {
      opacity: 0.5;
      background-color: black;
    }
    > svg {
      opacity: 1;
    }
  }
`;
